import { addToFavorite } from './services/reserved-area.js';

var filterItems = [];
var arrayFilter = { brand: [], period: [], dest: [] }; //filtri offerte per brand
var formactive = false;


$(function() {

    // ANCHOR LINK OFFSET
    $('a[href^="#"]').on("click", function(e) {
        e.preventDefault();
        if ($(".section-offerpromo-filter").length) {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $(this.hash).offset().top - 260
                },
                800
            );
        } else {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $(this.hash).offset().top - 160
                },
                800
            );
        }
    });

    if (window.location.href.indexOf("#") > -1) {
        // console.log(window.location.href.indexOf('#'))
        var href = window.location.href.split("#")[1];

		if(href === 'richiedi-preventivo') {
			$('#modal_form_quote').modal('show')
			let asset = window.location.hostname.split('.')
			asset = (asset ?? []).includes('nicolaus') ? 'nicolaus.it' : 'valtur.com'
		}

        $(window).on("load", function() {
            if ($("#" + href + " > .collapsed").length) {
                $("#" + href + " > .collapse").collapse("show");
            }
            if ($(".section-offerpromo-carousel #" + href).length) {
                $(".section-offerpromo-carousel .carousel-slider-for").slick(
                    "slickGoTo",
                    parseInt($("#" + href + "-for").data("slick-index"))
                );
            }
            if ($(".section-offerpromo-filter") && $(".section-offerpromo-filter").length) {
                $([document.documentElement, document.body]).animate(
                    {
                        scrollTop: $("#" + href).offset().top - 260
                    },
                    800
                );
            } else {
                $([document.documentElement, document.body]).animate(
                    {
                        scrollTop: $("#" + href).offset().top - 160
                    },
                    800
                );
            }
        });
    }
    // END ANCHOR LINK OFFSET

    // Tooltips Initialization
    $('[data-tool="tooltip"]').tooltip();

    if (
        window.location.pathname != "/" &&
        window.location.pathname != "/nicolausit/public/"
    ) {
        $("body").css({ "padding-top": $("header").height() });
    }

    // if (window.location.pathname == '/' || window.location.pathname == '/nicolausit/public/') {
    //   if ($(window).width() < 767) {
    //     $('header').eq(0).css('box-shadow', 'none');
    //     $('header').eq(0).css('background-color', 'rgba(244, 251, 255, 0.9)');
    //   } else {
    //     $('header').eq(0).css('box-shadow', '');
    //     $('header').eq(0).css('background-color', '');
    //   }
    // }

    $(window).on("load", function() {
        $("body").css({ transition: "all 0.3s ease-in-out" });
    });

    // FILTER STRUCTURE
    // $('.section-structure-filter.fixed-top').css({'margin-top': $('header').height()});
    // END FILTER STRUCTURE

    // TAB COLLAPSE
    // $('#structure-offers-tab').tabCollapse({
    //   tabsClass: 'd-none d-md-flex',
    //   accordionClass: 'd-block d-md-none'
    // });
    // END TAB COLLAPSE

    scrollNav();
    responsive();
    footerLinkCollapse();

    $(window).on("resize", function() {
        responsive();
        footerLinkCollapse();
    });

    // FILTER POPUP
    $("#navbar").on("shown.bs.collapse", function() {
        $("header").find(".popup").addClass("show");
        if ($(window).width() < 767) {
            $('body').css("overflow","hidden");
            $('nav.d-sm-none').css({'z-index':"1001",position: "relative",top: "35px"})
        }
    });

    $("#navbar").on("hidden.bs.collapse", function() {
        $('body').css("overflow","");
        if ($(window).width() < 767) {
            $(".popup").removeClass("show");
            $('nav.d-sm-none').css({'z-index':"1",position: "static",top: "35px"})
        }
    });

    $(".offer-filters-list .dropdown-toggle").on("click", function() {
        $(".popup").toggleClass("show");
    });
    $(".offer-filters-list .dropdown-item").on("click", function() {
        $(".popup").removeClass("show");
    });

    let filterObject = {
        dest: "",
        period: "",
        nMonth: null
    };

    $(".offer-filters-list .dropdown-item.period").on("click", function() {
        filterObject.nMonth = parseInt($(this).data("month"));
        filterObject.period = $(this).text();
        $(".section-offers-listbox").show();
        if ($(this).is(".default")) {
            filterObject.period = "";
            filterObject.nMonth = null;
            if (filterObject.dest !== "") {
                $.each($(".section-offers-listbox"), function() {
                    if (
                        $(this)
                            .data("destinations")
                            .indexOf(filterObject.dest) < 0
                    ) {
                        $(this).hide();
                    }
                });
            }
            $(".offer-filters-list .dropdown-toggle-name.fpsgg")
                .text("periodo di soggiorno")
                .removeClass("dropdown-toggle-name-style");
        } else {
            $(".offer-filters-list .dropdown-toggle-name.fpsgg")
                .text(filterObject.period)
                .addClass("dropdown-toggle-name-style");

            $.each($(".section-offers-listbox"), function() {
                if ($(this).data("expiry") < filterObject.nMonth) {
                    $(this).hide();
                }
                if (filterObject.dest !== "") {
                    if (
                        $(this)
                            .data("destinations")
                            .indexOf(filterObject.dest) < 0
                    ) {
                        $(this).hide();
                    }
                }
            });
        }
    });

    $(".offer-filters-list .dropdown-item.dest").on("click", function() {
        filterObject.dest = $(this).text();
        //  $('.dropdown-toggle span').text(textfilter);
        $(".section-offers-listbox").show();
        if ($(this).is(".default")) {
            filterObject.dest = "";
            if (filterObject.period !== "") {
                $.each($(".section-offers-listbox"), function() {
                    if ($(this).data("expiry") < filterObject.nMonth) {
                        $(this).hide();
                    }
                });
            }
            $(".offer-filters-list .dropdown-toggle-name.fdest")
                .text("destinazione")
                .removeClass("dropdown-toggle-name-style");
        } else {
            $(".offer-filters-list .dropdown-toggle-name.fdest")
                .text(filterObject.dest)
                .addClass("dropdown-toggle-name-style");

            $.each($(".section-offers-listbox"), function() {
                if (
                    $(this)
                        .data("destinations")
                        .indexOf(filterObject.dest) < 0
                ) {
                    $(this).hide();
                }

                if (filterObject.period !== "") {
                    if ($(this).data("expiry") < filterObject.nMonth) {
                        $(this).hide();
                    }
                }
            });
        }
    });

    /////////////////////FILTRI PAGINA OFFERTA GRUPPO

    $(".offer-filters-group .dropdown-item").on("click", function() {
        $(".offer-structure-box").show();
        var ref = $(this).data("ref");
        var isDefault = $(this).hasClass("default");
		var $placeholder = $("#f" + ref + "-plh");
		var oldText = $placeholder.text().trim();
		var text = $(this).text().trim();

        if (!isDefault) {
            $("#f" + ref).hide();
			if (oldText.includes(text)) {
				var newText = oldText
					.split(", ")
					.filter(item => item !== text)
					.join(", ");
				$placeholder.text(newText);
				arrayFilter[ref] = arrayFilter[ref].filter(item => item !== $(this).data('value'));
				if (!newText) {
					$placeholder.hide();
				}
			} else {
				var updatedText = oldText ? oldText + ", " + text : text;
				$placeholder.text(updatedText).show();
				arrayFilter[ref].push($(this).data('value'));
			}
        }
		if(isDefault || $placeholder.text() === '') {
			$("#f" + ref).show();
            $("#f" + ref + "-plh")
			.text("")
			.hide();
			arrayFilter[ref] = [];
		}

        $(".offer-structure-box").each(function(k, el) {
            var datael = $(el).data();
			console.log(arrayFilter.dest)
            if (arrayFilter.dest?.length && !arrayFilter.dest.includes(datael.destination)) {
                $(el).hide();
            }
            if (arrayFilter.period?.length && !arrayFilter.period.includes(datael.period)) {
                $(el).hide();
            }
            if (arrayFilter.brand?.length && !arrayFilter.brand.includes(datael.brand)) {
                $(el).hide();
            }
        });

        var displayShow = $(".offer-structure-box").filter(function(k, el) {
            return getComputedStyle(el).display !== "none";
        });
        $("#totresoffgr").text(displayShow.length);
    });

    $('.popup, button[data-target="#navbar"]').on("click", function() {
        $("#navbar").collapse("hide")
        $(".popup").removeClass("show")
        $("body").css("overflow", "")
    });
    // END FILTER POPUP

    // SECTION PAGE BRAND DETAILS
    $('[data-target*="#animation-details"]').on("click", function(e) {
        e.preventDefault();
        $(".section-brand-details-carousel").toggleClass("active");
    });
    // END SECTION PAGE BRAND DETAILS

    // SECTION NAVBAR SEARCH FORM
    // if (!$(".search-form").length) {
        // $("nav.navbar").removeClass("menu-open");
        // } else {
        //   if(!$('nav.navbar').hasClass('menu-open')) {
        //     $('nav.navbar').addClass('menu-open');
        //   }
    // }
    $(".search-nav-link").on("click", function() {
        if (formactive != $(this).attr("href")) {
            $(".search-form").removeClass("invisible");
            $(".search-form .tab-content.hidden").addClass("active");
            formactive = $(this).attr("href");
            $(".search-nav-link").removeClass("active");
            $('.search-nav-link[href*="' + formactive + '"]').addClass("active");
            $(".search-form .tab-content .tab-pane").removeClass("show active");
            $(formactive).tab("show");
        } else {
            $(".search-nav-link").removeClass("active");
            $(".search-form").addClass("invisible");
            $(".search-form .tab-content.hidden").removeClass("active");
            formactive = false;
        }

        if ($(".search-form .tab-content.hidden").hasClass("active")) {
            $("body").css({ "padding-top": $("header").height() });
            $("header").eq(0).css("box-shadow", "none");
            if ($(window).width() < 767) {
                $("body").css({ "padding-top": $("header").height() + 330 });
                $(".search-form-small").toggleClass("d-none");
            }
        } else {
            $("body").css({ "padding-top": $("header").height() });
            $("header").eq(0).css("box-shadow", "");
        }
    });

    $('body').on("click", ".close-search-form", function() {
        formactive = false;
        $(".search-nav-link").removeClass("active");
        $(".search-form .tab-content .tab-pane").removeClass("active show");
        $(".search-form .tab-content.hidden").toggleClass("active");
        $(".search-form").toggleClass("invisible");
        $("body").css({ "padding-top": $("header").height() });
        $("header").eq(0).css("box-shadow", "none");

        if ($(window).width() < 767) {
            $(".search-form-small").removeClass("d-none");
        }
    });
    // END SECTION NAVBAR SEARCH FORM

    // SECTION STRUCTURE FILTER
    $('[class^="section-structure-"]').not('.section-structure-title, .section-structure-stops').find('.h2').each(
        function() {
            filterItems.push({
                text: $(this).text(),
                height: $(this).height() + $(this).offset().top - 480
            });
            // console.log(filterItems)
            if ($(this).hasClass("security")) {
                $('<a class="nav-link security" href="#' +
                    $(this).text().split(" ")[0].toLowerCase() + '">' +
                    $(this).text().split(" ")[0] + "</a>"
                ).appendTo(".section-structure-filter .nav");
            } else {
                $('<a class="nav-link" href="#' +
                    $(this).text().split(" ")[0].toLowerCase() + '">' +
                    $(this).text().split(" ")[0] + "</a>"
                ).appendTo(".section-structure-filter .nav");
            }
            $('<a class="dropdown-item" href="#' +
                $(this).text().split(" ")[0].toLowerCase() +'">' +
                $(this).text().split(" ")[0] + "</a>"
            ).appendTo(".section-structure-filter .dropdown-menu");

            $('.section-structure-filter').show()
        }
    );
    $(".section-structure-filter .nav-link:not(.othlink, .tour-link)").on("click", function(e) {
        e.preventDefault();
        $([document.documentElement, document.body]).animate({ scrollTop: $(this.hash).offset().top - 240 },500,"swing");
        // console.log($(this.hash).offset().top -240)
    });
    $(".section-structure-filter .dropdown-item:not(.othlink, .tour-link)").on("click", function(e) {
        e.preventDefault();
        $([document.documentElement, document.body]).animate({ scrollTop: $(this.hash).offset().top - 130 }, 500, "swing");
        $($(this).prop("hash") + "-dropdown").collapse("show");
        $(".section-structure-filter .dropdown-toggle span").text( $(this).text() );
    });
    $(".section-structure-filter .tour-link").on("click", function(e) {
        e.preventDefault();
        $([document.documentElement, document.body]).animate({ scrollTop: $(this.hash).offset().top - 240 }, 500, "swing");
    });
    $(window).on("scroll", function() {
        for (var i = 0; i < filterItems?.length ?? 0; i++) {
            if (
                window.scrollY > filterItems[i].height ||
                window.pageYOffset > filterItems[i].height
            ) {
                $(".section-structure-filter .nav-link:not(.othlink, .tour-link)").each(function(
                    index,
                    value
                ) {
                    if (i == index) {
                        $(".section-structure-filter .nav-link:not(.othlink, .tour-link)").removeClass(
                            "active"
                        );
                        $(this).addClass("active");
                    }
                });
            } else if (
                window.scrollY < filterItems[0].height ||
                window.pageYOffset < filterItems[0].height
            ) {
                $(".section-structure-filter .nav-link:not(.othlink, .tour-link)").removeClass("active");
            }
        }
    });
    // END SECTION STRUCTURE FILTER


	$('#setstateaction').on("click",function() {
		const links = document.getElementsByClassName("btn-loginsl");
		const linkssignup = document.getElementsByClassName("btn-signupsl");

		// Prendi l'URL attuale dal tag <a>
		const url = new URL(links[0].href);
		const urlreg = new URL(linkssignup[0].href);

		// Cambia solo il parametro `state`
		url.searchParams.set("state", window.location.href+'?action=addFavorite');
		urlreg.searchParams.set("lastViewedUrl", window.location.href+'?action=addFavorite');

		// Aggiorna l'attributo href del link
		links[0].href = url.toString();
		linkssignup[0].href = urlreg.toString();
	})
	$('.addStrFavorite').on("click",function() {
		var idsf  = $(this).data('idsf')
		var sessSf  = $(this).data('idsf')
		var self  = $(this)
		addToFavorite(idsf, self)
		// $.ajax({
		// 	type: "POST",
		// 	url: window.appUrl + '/api/travel-preferences',
		// 	dataType: 'json',
		// 	headers: {
		// 		'Authorization-SF': window.AuthorizationSF
		// 	},
		// 	data: {
		// 		structureId: idsf
		// 	},
		// 	success: function(result, textStatus, xhr) {
		// 		//  $(this).hide()
		// 		if (xhr.status === 200) {
		// 			self.find("svg g path").attr("fill", "#18243D");
		// 		} else {
		// 			console.log(result);
		// 		}
		// 	},
		// 	error: function(xhr, textStatus, errorThrown) {
		// 		console.log("Errore nella richiesta AJAX: " + errorThrown);
		// 	}
		// })
	})


    // FORM CONTACT
    $('.shownewformc').on("click",function() {
        let typeBlock = $(this).attr('data-block')
        $('.'+ typeBlock + ' .sendok').hide()
        $('.'+ typeBlock + ' .sendko').hide()
        $('.'+ typeBlock + ' .nic_contact_form').show()
    })

    $('.nic_contact_form').on("submit", function (e)  {
        e.preventDefault()
        const typeBlock = $(this).attr('data-block')

        const selector = `.${typeBlock}`
        const alert_selector = `${selector} .is-legal-terms > .calert`
		const select_selector = `${selector} select`
        const radio_selector = `${selector} input[type="radio"]`
        const checkbox_selector = `${selector} input[type="checkbox"]`



		const isHaveActiveBooking = !$(`${checkbox_selector}#contact_form_haveActiveBooking`).is(":checked") || $(`${selector} input[name='contact_form[bookingCode]']`).val()

		const check_select_destinations = $(`${select_selector}[name='contact_form[destination]']`).find(':selected').val() !== ''
		const check_select_structures = $(`${select_selector}[name='contact_form[hotel]']`).find(':selected').val() !== ''

		const radio_privacy1 = !!$(`${radio_selector}[name='contact_form[privacy]']:checked`).length
        const radio_privacy2 = !!$(`${radio_selector}[name='contact_form[privacy2]']:checked`).length

        const isReasonInfoStructure = !!(['Informazioni su struttura o destinazione', 'Richiedi Preventivo'].includes($(`${select_selector}[name='contact_form[reason]']`).find(':selected').val()))

		if(!isHaveActiveBooking) {
			document.querySelectorAll(`${selector} input[name='contact_form[bookingCode]']`)[0].classList.add('alert-danger')
		// } else if(isReasonInfoStructure && !check_select_structures) {
		// 	document.querySelectorAll(`${selector} #contact_form_hotel`)[0].classList.add('alert-danger')
		} else if(isReasonInfoStructure && !(check_select_destinations || check_select_structures)) {
			document.querySelectorAll(`${selector} .alert-destination`)[0].classList.add('d-block')
			document.querySelectorAll(`${selector} #contact_form_destination`)[0].classList.add('alert-danger')
			document.querySelectorAll(`${selector} #contact_form_hotel`)[0].classList.add('alert-danger')
        } else if(!radio_privacy1 || !radio_privacy2) {
            !radio_privacy1 ? document.querySelectorAll(alert_selector)[0].classList.add('d-block') : document.querySelectorAll(alert_selector)[0].classList.remove('d-block')
            !radio_privacy2 ? document.querySelectorAll(alert_selector)[1].classList.add('d-block') : document.querySelectorAll(alert_selector)[1].classList.remove('d-block')
        } else {

            let recaptcha = $(this).attr('data-recaptcha')

            grecaptcha.ready(function() {
                grecaptcha.execute(recaptcha, {action: 'send_contact'}).then(function(token) {

                    $('.'+ typeBlock + ' .nic_contact_form').append($('<input type="hidden" id="recaptcha_token" name="recaptcha_token" value="' + token + '">'))
                    $('.'+ typeBlock + ' .nic_contact_form').hide()
                    $('.'+ typeBlock + ' .sendok').hide()
                    $('.'+ typeBlock + ' .sendko').hide()
                    $('.'+ typeBlock + ' .sendwait').show()

                    $.ajax({
                        type: "POST",
                        url: window.appUrl + '/api/request/contact',
                        dataType: 'json',
                        data: $('.'+ typeBlock + ' .nic_contact_form').serialize(),
                        success: function (result) {
                            $('.'+ typeBlock + ' .sendwait').hide()
                            //  $(this).hide()

                            if(typeof result.error !== 'undefined') {
                                $('.'+ typeBlock + ' .sendko').show()
                            }
                            else {
                                $("."+ typeBlock + " .nic_contact_form input[name!='_token'], ." + typeBlock + " .nic_contact_form select, ." + typeBlock + " .nic_contact_form textarea").val('')
                                if (typeof result.body !== 'undefined' && result.body.esito == 'KO') $('.'+ typeBlock + ' .sendko').show()
                                else $('.'+ typeBlock + ' .sendok').show()
                            }
                        },
                        error: function (data) {
                            //$(this).hide()
                            $('.'+ typeBlock + ' .sendwait').hide()
                            $('.'+ typeBlock + ' .sendko').show()
                        }
                    })
                })
            })
        }
    })
    // END FORM CONTACT




    function responsive() {
        if ($(window).width() < 767) {

            if ($('header').length) {
                let w = 0
                $('header').css('transition', 'all .3s ease-in')
                $(window).on('scroll', () => {
                    let st = $(this).scrollTop()
                    let ht = 1
                    if($('.breadcrumbspace').length) {
                        ht += 1
                        if (window.scrollY > 1) {
                            $('.breadcrumbspace').css('height', '0');
                        } else if (window.scrollY == 0) {
                            $('.breadcrumbspace').css('height', '15px');
                        }
                    }
                    if (window.scrollY > ht && st > w) {
                        // $('.search-form-small').css('opacity', '0')
                        // $('.search-form-small').addClass('invisible')
                        $('header').css('opacity', '0')
                        $('header').addClass('invisible')
                    }
                    else {
                        // $('.search-form-small').removeClass('invisible')
                        // $('.search-form-small').css('opacity', '1')
                        $('header').removeClass('invisible')
                        $('header').css('opacity', '1')
                    }
                    w = st
                    st += 10

                })
            }

            $(".footer .footer-link").first().css("border-top", "1px solid #fff");
        } else {
            // DROPDOWN NAVBAR
            $("header .navbar:not(.menu-open).navbar-expand-lg .dropdown")
                .on("mouseenter", function() {
                    $(".dropdown-toggle", this).dropdown("show");
                })
                .on("mouseleave", function() {
                    $(".dropdown-toggle", this).dropdown("hide");
                });
            $("header .dropdown .dropdown-toggle").on("click", function() {
                if ($(this).attr("href"))
                    window.location = $(this).attr("href");
            });
            // END DROPDOWN NAVBAR
            $(".footer .footer-link").first().css("border-top", "none");
        }
    }

    function scrollNav() {
        if (
            $(window).width() > 767 &&
            $(".search-result-structure-filter-navbar img").length
        ) {
            $(window).on("scroll", function() {
                if (window.scrollY > 30) {
                    $(".search-result-structure-filter-navbar img").css(
                        "opacity",
                        "0"
                    );
                    $(".search-result-structure-filter-navbar img").css(
                        "margin-bottom",
                        "0"
                    );
                    $(".search-result-structure-filter-navbar img").css(
                        "height",
                        "0"
                    );
                } else {
                    $(".search-result-structure-filter-navbar img").removeAttr(
                        "style"
                    );
                }
            });
        }
    }

    function footerLinkCollapse() {
        if ($(window).width() < 767) {
            $(".footer-link .collapse").removeClass("show");
            $(".footer-link .h4").attr("data-toggle", "collapse");
            $(".footer-link .h4").attr("role", "button");
        } else {
            $(".footer-link .collapse").addClass("show");
            $(".footer-link .h4").removeAttr("data-toggle", "collapse");
            $(".footer-link .h4").removeAttr("role", "button");
        }
    }
})
